// Factory function pattern to avoid Webpack TDZ issues with class inheritance
// This uses BaseSuperAdminFactory instead of class inheritance

import { createBaseSuperAdmin, type IBaseSuperAdmin } from "../BaseSuperAdminFactory";
import type { FilesInstance } from "./helpers/filesInstanceHelpers";
import { createFilesInstance } from "./helpers/filesInstanceHelpers";
import { createApiFactory } from "@Front/Api/helpers/BaseApiFactoryGenerator";

const factory = createApiFactory<IBaseSuperAdmin, FilesInstance>({
	name: "Files",
	createBase: createBaseSuperAdmin,
	createInstance: createFilesInstance,
});

export function getFilesInstance(): FilesInstance {
	return factory.getInstance();
}
